import { PublicUserGq, PublicUserGqProps } from './PublicUserGq';

export interface TeamConnectionInvitationGq {
  id: number;
  sentByUser?: PublicUserGq;
  sentTime?: string;
  sentToEmail?: string;
  tokenExpirationTime?: string;
}

export const TeamConnectionInvitationGqProps = `
  id
  sentByUser { ${PublicUserGqProps} }
  sentTime
  sentToEmail
  tokenExpirationTime
`;
